import { lazy, type ComponentType } from "react";

type Importer<T extends ComponentType<unknown>> = () => Promise<{ default: T }>;

interface LazyRoute<T extends ComponentType<unknown>> {
  Component: ReturnType<typeof lazy<T>>;
  /** Préchage le chunk (au hover/focus, ou en idle). Idempotent. */
  preload: () => Promise<{ default: T }>;
}

/**
 * Stratégie KISS:
 *  - lazy() pour le découpage natif du bundle Vite.
 *  - preload() exposé pour l'amorcer avant la navigation (hover/focus/idle).
 *  - Une promesse partagée → pas de double download, pas de race.
 */
export function lazyWithPrefetch<T extends ComponentType<unknown>>(
  importer: Importer<T>,
): LazyRoute<T> {
  let cached: Promise<{ default: T }> | null = null;
  const load = () => (cached ??= importer());
  return {
    Component: lazy(load),
    preload: load,
  };
}
